import { celo } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createCeloChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createCeloChainCustom({
    client: createClient({
      chain: celo,
      httpRpcs: celoHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'CeloScan',
      baseUrl: 'https://celoscan.io',
      chainId: 42_220,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateCeloChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createCeloChainCustom = ({
  client,
  explorer,
}: CreateCeloChainCustomParameters): Chain => ({
  id: 42_220,
  network: 'celo',
  name: 'Celo',
  nativeToken: {
    name: 'Celo',
    symbol: 'CELO',
    decimals: 18,
    currency: {
      symbol: 'CELO',
      type: 'CryptoCurrency',
      id: 'celo',
      name: 'Celo',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x471ece3750da237f93b8e339c536989b8978a438',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'celo',
  defillamaId: undefined,
})

export const celoHttpRpcs: HttpRpc[] = [
  {
    url: 'https://forno.celo.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.ankr.com/celo',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://celo-mainnet.gateway.tatum.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://celo.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://celo-json-rpc.stakely.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://celo.api.onfinality.io/public',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
]

export const celoWebsocketRpcUrls: string[] = ['wss://celo.drpc.org']
